import { Location } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { take } from 'rxjs';

import { ExtendedProfile } from 'src/app/common/ExtendedProfile';
import { ProfileRoleConstants } from 'src/app/common/ProfileRole';
import { AppProfileService } from 'src/app/services/profile.service';
import { NotificationSettingsComponent } from './notification-settings.component';
import { PersonalizationSettingsComponent } from './personalization-settings.component';
import { PrinterSettingsComponent } from './printer-settings.component';
import { SettingsPageStore } from './settings-page.store';
import { UserSettingsComponent } from './user-settings.component';

/**
 * The settings page: which tabs this user sees, and nothing else (#199). Each tab's content is a
 * section component with its own form and save; {@link SettingsPageStore} gives them the rows.
 */
@Component({
  imports: [
    TabStripModule,
    PrinterSettingsComponent,
    NotificationSettingsComponent,
    UserSettingsComponent,
    PersonalizationSettingsComponent,
  ],
  providers: [SettingsPageStore],
  selector: 'appshop--settings',
  templateUrl: './settings.component.html',
})
export class SettingsComponent implements OnInit {
  private readonly appProfileService = inject(AppProfileService);
  private readonly location = inject(Location);
  private readonly store = inject(SettingsPageStore);

  public profile: ExtendedProfile;
  // #670: the Customer-scoped rows are writable by admins only — every admin gets the
  // Benachrichtigungen tab. #648: only retailers print receipts, so the System tab (printer)
  // is for retailer admins.
  public isAdmin = false;
  public showSystemTab = false;

  ngOnInit(): void {
    this.appProfileService.currentProfile$.pipe(take(1)).subscribe((profile) => {
      // Set before the template renders a section: every section reads it at construction.
      this.store.profile = profile;
      this.profile = profile;
      this.isAdmin = profile?.role == ProfileRoleConstants.RoleIdAdmin;
      this.showSystemTab = this.isAdmin && !!profile?.customer?.isRetailer;
    });
  }

  onBackClicked() {
    this.location.back();
  }
}
